export const PAYMENT_CODE_REQUIRES_AUTHENTICATION = 'requires_authentication';

export const PAYMENT_CODES_REQUIRES_PAYMENT_METHOD = {
    REQUIRES_SOURCE: 'requires_source',
    REQUIRES_PAYMENT_METHOD: 'requires_payment_method',
};
